import { useCallback } from 'react';
import * as turf from '@turf/turf';

const useGeoJSONCenter = () => {
  return useCallback(geoJSON => {
    try {
      if (geoJSON?.geometry?.type === 'Polygon') {
        const center = turf.center(geoJSON);
        return {
          lat: center.geometry.coordinates[1],
          lng: center.geometry.coordinates[0]
        };
      }
      return null;
    } catch (error) {
      console.error('Error calculating GeoJSON center:', error);
      return null;
    }
  }, []);
};

export default useGeoJSONCenter;
